export function filterNills<T>(array: Array<T | undefined | null>): Array<T> {
  return array.filter(
    element => element !== undefined && element !== null
  ) as Array<T>;
}
